import componentShell from "./shell"
import SignsTagContent from "@/client/components/signs/tag_content"

export default componentShell(SignsTagContent)
